import styled from 'styled-components'
import footerbanner from './footerbanner.png'
import footerbannerMobile from './footerbanner-mobile.png'
const mobile = 'max-width: 1000px'

export const Root = styled.div`
  background-image: url(${footerbanner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 573px;

  @media only screen and (${mobile}) {
    background-image: url(${footerbannerMobile});
    background-repeat: no-repeat;
    background-position: center top;
    color: #000;
    height: 440px;
    padding-bottom: 15px;
    box-sizing: border-box;
    justify-content: flex-end;
  }
`

export const Title = styled.h2`
  font-family: Helvetica Neue;
  font-size: 40px;
  font-weight: 700;
  line-height: 80px;
  letter-spacing: 0em;
  text-align: center;
  margin: 0;
  @media only screen and (${mobile}) {
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 5px;
    max-width: 370px;
  }
`

export const Subtitle = styled.span`
  font-family: Helvetica Neue;
  font-size: 24px;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 58px;
  @media only screen and (${mobile}) {
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 24px;
    &:last-child {
      display: block;
      margin-top: 24px;
    }
  }
`

export const LogIn = styled.button`
  color: #ff5e6d;
  text-decoration: underline;
  font-size: 14px;
  line-height: 17px;
  font-family: Helvetica Neue;
  font-weight: 700;
  letter-spacing: 0em;
  border: 0;
  padding: 0;
  margin: 0;
  background: none;
`
